module.exports = __webpack_public_path__ + "static/conv1d-a5b5870ab0a4030684c7f5796e3b83a6.gif";